import { server } from "../lib/axios-client";

const generateJwt = (email) => {
  server
    .post("jwt", { email })
    .then((res) => {
      // setToken(res.data.token);
      console.log(res.data.token);
      localStorage.setItem("token", res.data.token);
    })
    .catch((err) => {
      console.log("first");
      console.log(err);
    });
};
export default generateJwt;
